
import React, { useState } from 'react';
import '../../../styles/CompanySearch.css';

interface CompanyFormProps {
  onSubmit: (companyName: string, contactPerson: string) => void;
  isLoading: boolean;
}

/**
 * Form component for entering company name and contact person
 */
const CompanyForm: React.FC<CompanyFormProps> = ({ onSubmit, isLoading }) => {
  const [companyName, setCompanyName] = useState('');
  const [contactPerson, setContactPerson] = useState('');
  const [errors, setErrors] = useState({
    companyName: '',
    contactPerson: ''
  });

  /**
   * Validate form inputs
   * @returns True if valid, false otherwise
   */
  const validateForm = (): boolean => {
    const newErrors = {
      companyName: '',
      contactPerson: ''
    };
    let isValid = true;

    if (!companyName.trim()) {
      newErrors.companyName = 'Company name is required';
      isValid = false;
    }

    if (!contactPerson.trim()) {
      newErrors.contactPerson = 'Contact person is required';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  /**
   * Handle form submission
   * @param e Form event
   */
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (validateForm()) {
      onSubmit(companyName, contactPerson);
    }
  };

  return (
    <div className="company-form">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="companyName" className="form-label">
            Company Name
          </label>
          <input
            type="text"
            id="companyName"
            className="form-input"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            placeholder="Enter company name"
            disabled={isLoading}
          />
          {errors.companyName && (
            <div className="error-message">{errors.companyName}</div>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="contactPerson" className="form-label">
            Key Contact Person
          </label>
          <input
            type="text"
            id="contactPerson"
            className="form-input"
            value={contactPerson}
            onChange={(e) => setContactPerson(e.target.value)}
            placeholder="Enter key contact person"
            disabled={isLoading}
          />
          {errors.contactPerson && (
            <div className="error-message">{errors.contactPerson}</div>
          )}
        </div>

        <button
          type="submit"
          className="form-button"
          disabled={isLoading}
        >
          {isLoading ? 'Searching...' : 'Find Similar Companies'}
        </button>
      </form>
    </div>
  );
};

export default CompanyForm;
